<template>
  <Dialog
      :header="t('CONFIRM_TITLE')"
      v-model:visible="visible"
      modal
      :draggable="false"
      :dismissable-mask="true"
      @hide="onHide"
  >
    <div class="mb-2">
      <label for="id-proceed-reason" class="form-label">{{ props.reasonLabel }}</label>
      <Textarea
          id="id-proceed-reason"
          v-model="reason"
          class="w-100"
          :invalid="props.reasonRequired && validationPending && !reason"
          rows="3"
      />
    </div>

    <template #footer>
      <Button :label="t('CANCEL')" severity="secondary" @click="visible = false"/>
      <Button :label="props.confirmButtonLabel || t('CONFIRM')" @click="onConfirm"/>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import {computed, ref} from "vue";
import {useI18n} from "vue-i18n";
import {useToast} from "@/util/toastUtils";

const {t} = useI18n();
const toast = useToast();

const visible = ref(false);
const institutionDiplomaId = ref<string>("");
const reason = ref<string>("");
const validationPending = ref(false);

const props = defineProps<{
  reasonRequired: boolean;
  reasonLabel: string;
  confirmButtonLabel?: string;
}>();


const emit = defineEmits<{
  confirm: [institutionDiplomaId: string, reason: string]
}>();

const formValid = computed(() => {
  return !props.reasonRequired || !!reason.value;
});

const onHide = () => {
  visible.value = false;
};

const showConfirmationModal = (id: string) => {
  validationPending.value = false;
  reason.value = "";
  institutionDiplomaId.value = id;
  visible.value = true;
};

const onConfirm = async (ev: Event) => {
  ev.preventDefault();

  if (!formValid.value) {
    validationPending.value = true;
    toast.makeErrorToast(t("ERRORS.FORM_INVALID"));
    return;
  }

  validationPending.value = false;
  await emit("confirm", institutionDiplomaId.value, reason.value);
  visible.value = false;
};

defineExpose({
  showConfirmationModal,
});
</script>
